import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "4 17 10 11 4 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "20", y1: "19", y2: "19", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Terminal";
const Terminal = memo(themed(Icon));
export {
  Terminal
};
//# sourceMappingURL=terminal.js.map
